import * as React from "react";
const SvgFiRrBanjo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-banjo_svg__a)">
      <path
        fill="#062147"
        d="m23.491 1.104-.592-.593A1.74 1.74 0 0 0 20.437.51l-.557.554A3 3 0 0 0 19 3.186v.4l-6.097 6.097A7.96 7.96 0 0 0 8 8c-4.411 0-8 3.59-8 8s3.589 8 8 8 8-3.589 8-8a7.96 7.96 0 0 0-1.683-4.903L20.414 5h.396a3 3 0 0 0 2.12-.877l.559-.557c.68-.679.681-1.782.002-2.462M8 22c-3.309 0-6-2.69-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6m.707-4.707a.999.999 0 1 1-1.414 1.414l-2-2a.999.999 0 1 1 1.414-1.414z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-banjo_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBanjo;
